var _excluded = ["device"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { MediaQueryProvider } from 'react-media-query-hoc';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DeviceTypes = ['desktop', 'tv', 'tablet', 'phone', 'bot', 'car'];
var breakpoints = {
  mobileMinWidth: 0,
  mobileMaxWidth: 623,
  tabletMinWidth: 624,
  tabletMaxWidth: 1020,
  desktopMinWidth: 1021,
  desktopNewHeaderMinWidth: 1080,
  desktopMaxWidth: 1440,
  largeDesktopMinWidth: 1800,
  smallTabletMaxWidth: 920
};
var getWidthFromDevice = device => {
  switch (device) {
    case 'desktop':
    case 'bot':
      return breakpoints.desktopMaxWidth;
    case 'tablet':
      return breakpoints.tabletMaxWidth;
    default:
      return breakpoints.mobileMaxWidth;
  }
};
export var queries = {
  mobile: "(max-width: ".concat(breakpoints.mobileMaxWidth, "px)"),
  tablet: "(min-width: ".concat(breakpoints.tabletMinWidth, "px) and (max-width: ").concat(breakpoints.tabletMaxWidth, "px)"),
  desktop: "(min-width: ".concat(breakpoints.desktopMinWidth, "px)"),
  desktopNewHeader: "(min-width: ".concat(breakpoints.desktopNewHeaderMinWidth, "px)"),
  smallTablet: "(min-width: ".concat(breakpoints.tabletMinWidth, "px) and (max-width: ").concat(breakpoints.smallTabletMaxWidth, "px)"),
  desktopExtraWide: "screen and (min-width: ".concat(breakpoints.largeDesktopMinWidth, "px)"),
  landscapeMobile: "(min-width: ".concat(breakpoints.tabletMinWidth, "px) and (max-height: ").concat(breakpoints.mobileMaxWidth, "px)")
};
var withMediaQueryProvider = WrappedComponent => {
  var Enhance = props => {
    var _props$device = props.device,
      device = _props$device === void 0 ? 'phone' : _props$device,
      otherProps = _objectWithoutProperties(props, _excluded);
    var values = {
      width: getWidthFromDevice(device)
    };
    return ___EmotionJSX(MediaQueryProvider, {
      queries: queries,
      values: values
    }, ___EmotionJSX(WrappedComponent, otherProps));
  };
  Enhance.displayName = "MediaQueryProvider(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
  return hoistNonReactStatic(Enhance, WrappedComponent);
};
export default withMediaQueryProvider;